export const withdrawal_requests_selection = `
    trace_id
    date
    amount
    currency
    payment_method {
      key
      title
      option_id
      option_type
      image
      image_dark_mode
      payment_rail {
        key
        title
      }
    }
`;

export const get_withdrawl_requests_query = `
  query Withdrawal_requests {
  withdrawal_requests {${withdrawal_requests_selection}}
}`;
